import React from 'react';
import ColoresManager from '../Components/Catalogos/Colores/ColoresManager';

/**
 * ColoresPage - Página principal para la gestión de identidad visual.
 * Muestra el gestor visual (Premium Grid Layout - Tarjetas).
 */
export default function ColoresPage() {
    return (
        <ColoresManager />
    );
}
